module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTY3MiA4NjRhMzIgMzIgMCAwIDEgMCA2NEgzNTJhMzIgMzIgMCAwIDEgMC02NGgzMjB6TTUzMi44IDU2LjlhMzIgMzIgMCAwIDEgMy41IDMuNWwzMTQuNCAzNjYuOGEzMiAzMiAwIDAgMS0yNC4zIDUyLjhINzA0djI4OGEzMiAzMiAwIDAgMS0zMiAzMkgzNTJhMzIgMzIgMCAwIDEtMzItMzJ2LTI4OEgxOTcuNmEzMiAzMiAwIDAgMS0yNC4zLTUyLjhsMzE0LjQtMzY2LjhhMzIgMzIgMCAwIDEgNDUuMS0zLjV6TTUxMiAxMzAuM0wyNjcuMSA0MTZIMzg0djMyMGgyNTZWNDE2aDExNi45TDUxMiAxMzAuM3oiIGZpbGw9IiMwIiBwLWlkPSIxMzM1Ij48L3BhdGg+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Upgrade-outlined.svg
// module id = cI3k
// module chunks = 74